import useSWR, { SWRResponse } from 'swr';
import type { AxiosError } from 'axios';
import { Agent, ManagerGoal } from '../../../providers/api/dtos';
import { getManagerGoalByAgentId } from '../../../providers/api/goal/goalProvider';
import { API_GOALS_PATH } from '../../../providers/api/api';

export const MANAGER_GOAL_RID = `${API_GOALS_PATH}/manager/:agentId`;

export default function useManagerGoal(agentId?: Agent['id']): SWRResponse<ManagerGoal, AxiosError> {
  return useSWR(agentId ? [MANAGER_GOAL_RID, agentId] : null, () => getManagerGoalByAgentId(agentId!));
}
